// extracted by mini-css-extract-plugin
export default {"root":"sfzbD_75Cm4oGycxy2Tb","label":"LrbqrjSBiPxrobJ0EFen","placeHolderShimmer":"ozka9fMmkO0OEumayCQo"};